export default () => import(/* webpackChunkName: 'coffee/app/agreement/privacy' */ './Privacy');
